import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {labels} from '../../../../../util/utils';

import {filterContacts} from '../../../../../actions/ContactDB';

import Form from '@ey/canvascoreservices/Form';
import Search from '../../../../CoreWrappers/Search';
import StyledToolbarSearch from './StyledToolbarSearch';

const ToolbarSearch = () => {
	const SEARCH = 'searchContacts';

	const dispatch = useDispatch();

	const handleSearch = (value) => dispatch(filterContacts({userSearch: value}));

	const initialValues = {[SEARCH]: ''};
	const schema = {[SEARCH]: {required: false, maxLength: 0, excludeRichText: false}};
	const props = {initialValues, schema, onSubmit: () => null};

	useEffect(() => {
		return () => {
			handleSearch(null);
		};
	}, []);

	return (
		<Form {...props}>
			{({values, handleChange}) => {
				const renderSearch = () => {
					const id = SEARCH;

					const onEnter = () => {
						const newValue = values[id].trim();
						handleSearch(newValue);
						handleChange(id, newValue);
					};

					const props = {
						placeholder: labels[id],
						value: values[id],
						onChange: (val) => handleChange(id, val),
						onEnter,
						onSearchButtonClick: onEnter,
						searchButtonTitle: labels.searchTitletip,
						onClear: () => {
							handleChange(id, initialValues[id]);
							handleSearch(initialValues[id]);
						}
					};

					return <Search {...props} />;
				};

				return <StyledToolbarSearch className="search">{renderSearch()}</StyledToolbarSearch>;
			}}
		</Form>
	);
};

export default ToolbarSearch;
